import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ConfirmErrorIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 64 64"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="#FEF3F2" height="64" rx="32" width="64" />
    <rect fill="#FEE4E2" height="48" rx="24" width="48" x="8" y="8" />
    <g clipPath="url(#clip0_4718_45136)">
      <rect fill="#D92D20" height="32" rx="16" width="32" x="16" y="16" />
      <circle cx="32" cy="32" fill="white" r="8" />
      <path
        clipRule="evenodd"
        d="M32 18.6667C24.6362 18.6667 18.6666 24.6362 18.6666 32C18.6666 39.3638 24.6362 45.3334 32 45.3334C39.3638 45.3334 45.3333 39.3638 45.3333 32C45.3333 24.6362 39.3638 18.6667 32 18.6667ZM28.9428 27.0572C28.4221 26.5365 27.5778 26.5365 27.0572 27.0572C26.5365 27.5779 26.5365 28.4221 27.0572 28.9428L30.1143 32L27.0572 35.0572C26.5365 35.5779 26.5365 36.4221 27.0572 36.9428C27.5778 37.4635 28.4221 37.4635 28.9428 36.9428L32 33.8856L35.0572 36.9428C35.5779 37.4635 36.4221 37.4635 36.9428 36.9428C37.4635 36.4221 37.4635 35.5779 36.9428 35.0572L33.8856 32L36.9428 28.9428C37.4635 28.4221 37.4635 27.5779 36.9428 27.0572C36.4221 26.5365 35.5779 26.5365 35.0572 27.0572L32 30.1144L28.9428 27.0572Z"
        fill="#D92D20"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_4718_45136">
        <rect fill="white" height="32" rx="16" width="32" x="16" y="16" />
      </clipPath>
    </defs>
  </svg>
);

ConfirmErrorIcon.propTypes = {
  ...sizePropsTypes,
};

export default ConfirmErrorIcon;
